import { h, Host } from "@stencil/core";
import { limitSlotElements } from "../../utils/limitSlotElements";
import { getAuthClient } from "@trumpf/ux.utils";
/**
 * This component is used to display an image that requires authentication.
 */
export class AuthImage {
    constructor() {
        this.imageElement = null;
        this.authClient = null;
        this.handleSlot = () => {
            this.imageElement = this.host.querySelector("ux-image");
            this.requestImage();
        };
        this.src = undefined;
        this.header = {};
        this.token = null;
    }
    requestImage() {
        if (this.imageElement === null || !this.src || (Object.keys(this.header).length === 0 && this.token === null)) {
            return;
        }
        if (this.src === "" || this.authClient === null) {
            this.imageElement.error = true;
            return;
        }
        const headers = new Headers();
        if (this.token !== null) {
            headers.append("Authorization", `Bearer ${this.token}`);
        }
        for (const [key, value] of Object.entries(this.header)) {
            headers.append(key, value);
        }
        this.imageElement.spinner = true;
        this.imageElement.error = false;
        fetch(this.src, { headers })
            .then((response) => {
            if (response.ok) {
                return response.blob();
            }
            else {
                throw new Error("Network response was not ok.");
            }
        })
            .then((blob) => {
            const url = URL.createObjectURL(blob);
            this.imageElement.src = url;
            this.imageElement.spinner = false;
            const onReady = () => {
                URL.revokeObjectURL(url);
                this.imageElement.removeEventListener("uxReady", onReady);
            };
            this.imageElement.addEventListener("uxReady", onReady);
        })
            .catch((error) => {
            this.imageElement.error = true;
            this.errorEvent.emit({
                error,
                src: this.src
            });
        });
    }
    componentDidLoad() {
        this.authClient = getAuthClient();
        limitSlotElements(this.host, {
            allowed: {
                "": ["ux-image"]
            }
        });
        this.host.shadowRoot.addEventListener("slotchange", () => {
            this.handleSlot();
        });
        this.handleSlot();
        this.subscriber = (token) => {
            this.token = token;
        };
        this.authClient.subscribe(this.subscriber);
        this.token = this.authClient.getAccessToken();
    }
    disconnectedCallback() {
        if (this.authClient !== null)
            this.authClient.unsubscribe(this.subscriber);
    }
    render() {
        return (h(Host, { key: '846b7f1c5c73d7385c35578b68b89925574583e1' }, h("slot", { key: '46e9ae149371f95a4c30f78ef6e65f0c47cfd69f' })));
    }
    static get is() { return "uxc-auth-image"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["auth-image.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["auth-image.css"]
        };
    }
    static get properties() {
        return {
            "src": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The image source"
                },
                "attribute": "src",
                "reflect": false
            },
            "header": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "object",
                    "resolved": "object",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "the http header for the image request"
                },
                "defaultValue": "{}"
            }
        };
    }
    static get states() {
        return {
            "token": {}
        };
    }
    static get events() {
        return [{
                "method": "errorEvent",
                "name": "uxError",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Event that is emitted when an error occurs loading the image."
                },
                "complexType": {
                    "original": "{ error: object; src: string }",
                    "resolved": "{ error: object; src: string; }",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "host"; }
    static get watchers() {
        return [{
                "propName": "src",
                "methodName": "requestImage"
            }, {
                "propName": "header",
                "methodName": "requestImage"
            }, {
                "propName": "token",
                "methodName": "requestImage"
            }];
    }
}
//# sourceMappingURL=auth-image.js.map
